import ReactGA from 'react-ga';

export const useAnalyticsEventTracker = (category: string, value?: number) => {
  const eventTracker = (action = 'test action', label = 'test label') => {
    ReactGA.event({ category, action, label, value });
  };
  return eventTracker;
};
